

export class Area {
    public static get transportation() { return 'Transportation' };
    public static get factoring() { return 'Factoring' };
    public static get test() { return 'Test' };
    public static get core() { return 'Core' };
    public static get auth() { return 'Auth' };
    public static get secure() { return 'Secure' };
    public static get telerik() { return 'Telerik' };
}


// WEBPACK FOOTER //
// ./src/app/core/constants/area.ts